import React, { useEffect, useState } from 'react';
import { AppStoreButton } from './AppStoreButton';
import { PlayStoreButton } from './PlayStoreButton';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-sm py-3' : 'py-4'}`} data-id="element-62" data-mp="4lhx6b8xsaos">
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center" data-id="element-63" data-mp="ejxifxla8pqd">
        <div className="text-2xl font-black tracking-tight text-black" data-id="element-64" data-mp="9kb6drh6xfj5">
          Croon.
        </div>
        <div className="flex items-center gap-2" data-id="element-65" data-mp="1pyazojlj66xf">
          <AppStoreButton data-id="element-66" data-mp="1pwzxupbnb98y" />
          <PlayStoreButton className="hidden sm:flex" data-id="element-67" data-mp="1q0e1s1zyjqii" />
        </div>
      </div>
    </nav>;
}